import tw, { styled } from "twin.macro";
import "antd/dist/antd.css";
import { Input } from "antd";

const { TextArea } = Input;

export const TimelinePostContainer = styled.div`
	${tw`rounded-md flex flex-col relative h-full w-full relative`}
	.ant-comment-content {
		background-color: #f5f5f5;
		padding: 10px;
		border-radius: 10px;
	}

	.ant-comment-content-author-name {
		color: #323232;
		font-family: "Manrope";
		font-weight: 700;
	}
`;

export const PostComment = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	gap: 10px;
	margin-top: 12px;
	margin-bottom: 12px;
	height: 100%;
	position: relative;
`;

export const TextAreaComment = styled(TextArea)`
	textarea.ant-input {
		background-color: #f5f5f5;
		border-radius: 50px;
		min-width: 125px;
		@media (max-width: 900px) {
			border-radius: 16px !important;
		}
	}
	width: 100%;
`;
